import React from 'react';

import { useStaticQuery, graphql, Link } from 'gatsby'

function UserExperienceReportList () {

    function format_report_type(type) {
        const labels = {
            "libspace":"Space",
            "libwebsite":"Website",
            "libservices":"Services",
            "community":"External",
            "other-uxreport":"Internal"
        }
    
        if(!(type in labels)) {
            return null;
        }
        
        return labels[type];
    }

    const data = useStaticQuery(graphql`
        query UXReportQuery {
            reports: allNodeUserExperienceReport(
            sort: [{field_ux_year_of_study: DESC}, {title: ASC}]
            ) {
                edges {
                    node {
                    path {
                        alias
                    }
                    title
                    created
                    field_ux_link {
                        uri
                    }
                    field_ux_report_type
                    field_ux_short_description
                    body {
                        processed
                    }
                    changed
                    field_ux_year_of_study
                    }
                }
            }
        }
    `);

    const reports = data.reports.edges;

    // Format rows
    let collection_rows = reports.map((element) => {
        return (
            <tr className="table-row">
                <td><Link to={element.node.path.alias}>{element.node.title}</Link></td>
                <td dangerouslySetInnerHTML={{__html: element.node.field_ux_short_description}}></td>
                <td>{element.node.field_ux_year_of_study}</td>
                <td>{format_report_type(element.node.field_ux_report_type)}</td>
            </tr>
        )
    })

    return (<>
        <h2>User Experience Reports</h2>
        <p>Curious about what we’ve been up to? Check out some of our studies below.</p>
        <table className="ux-reports">
            <caption>A list of reports completed  by the User Experience team</caption>
            <tr className="header">
                <th scope="col">Title</th>
                <th scope="col">Description</th>
                <th scope="col">Year</th>
                <th scope="col">Study Type</th>
            </tr>
            {collection_rows}
        </table>
    </>);
       
}

export default UserExperienceReportList